import React, { Suspense, lazy } from 'react';
import { createBrowserRouter } from 'react-router-dom';
import Layout from '@/components/Layout';
import LoadingSpinner from '@/components/LoadingSpinner';

// 懶加載頁面組件
const HomePage = lazy(() => import('@/pages/HomePage'));
const AboutPage = lazy(() => import('@/pages/AboutPage'));
const FAQPage = lazy(() => import('@/pages/FAQPage'));
const ContactPage = lazy(() => import('@/pages/ContactPage'));
const TermsPage = lazy(() => import('@/pages/TermsPage'));
const PrivacyPage = lazy(() => import('@/pages/PrivacyPage'));
const ReturnPolicyPage = lazy(() => import('@/pages/ReturnPolicyPage'));
const TicketPage = lazy(() => import('@/pages/TicketPage'));
const LoginPage = lazy(() => import('@/pages/LoginPage'));
const ProfilePage = lazy(() => import('@/pages/ProfilePage'));
const CoursesPage = lazy(() => import('@/pages/CoursesPage'));
const ClassifyPage = lazy(() => import('@/pages/ClassifyPage'));
const RegionPage = lazy(() => import('@/pages/RegionPage'));
const CityPage = lazy(() => import('@/pages/CityPage'));
const DistrictPage = lazy(() => import('@/pages/DistrictPage'));
const ProductDetailPage = lazy(() => import('@/pages/ProductDetailPage'));
const ServicePage = lazy(() => import('@/pages/ServicePage'));
const GenericPage = lazy(() => import('@/pages/GenericPage'));
const RegisterPage = lazy(() => import('@/pages/RegisterPage'));
const ForgotPasswordPage = lazy(() => import('@/pages/ForgotPasswordPage'));
const ResetPasswordPage = lazy(() => import('@/pages/ResetPasswordPage'));
const PromotionPage = lazy(() => import('@/pages/PromotionPage'));
const OrderConfirmationPage = lazy(() => import('@/pages/OrderConfirmationPage'));
const CheckoutPage = lazy(() => import('@/pages/CheckoutPage'));


// 懶加載包裝器
const LazyWrapper: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <Suspense fallback={<LoadingSpinner />}>
    {children}
  </Suspense>
);

export const router = createBrowserRouter([
  {
    path: '/',
    element: <Layout />,
    children: [
      // 區塊化路由----start
      {
        path: ':region',
        element: <LazyWrapper><RegionPage /></LazyWrapper>,
      },
      {
        path: ':region/:city',
        element: <LazyWrapper><CityPage /></LazyWrapper>,
      },
      {
        path: ':region/:city/:district',
        element: <LazyWrapper><DistrictPage /></LazyWrapper>,
      },
      // 區塊化路由----end

      {
        index: true,
        element: <LazyWrapper><HomePage /></LazyWrapper>,
      },
      {
        path: '/service/about',
        element: <LazyWrapper><AboutPage /></LazyWrapper>,
      },
      {
        path: 'login',
        element: <LazyWrapper><LoginPage /></LazyWrapper>,
      },
      {
        path: 'register',
        element: <LazyWrapper><RegisterPage /></LazyWrapper>,
      },
      {
        path: 'forgot-password',
        element: <LazyWrapper><ForgotPasswordPage /></LazyWrapper>,
      },
      {
        path: 'reset-password',
        element: <LazyWrapper><ResetPasswordPage /></LazyWrapper>,
      },
      {
        path: 'profile',
        element: <LazyWrapper><ProfilePage /></LazyWrapper>,
      },
      {
        path: 'courses',
        element: <LazyWrapper><CoursesPage /></LazyWrapper>,
      },
      // 分類頁面
      {
        path: 'category/:categoryId',
        element: <LazyWrapper>< ClassifyPage /></LazyWrapper>,
      },
      // 行銷活動頁面
      {
        path: 'promotion/:promotionId',
        element: <LazyWrapper>< PromotionPage /></LazyWrapper>,
      },
      // 產品詳情頁面
      {
        path: 'product/:productId',
        element: <LazyWrapper><ProductDetailPage /></LazyWrapper>,
      },
      {
        path: 'serticket',
        element: <LazyWrapper><TicketPage /></LazyWrapper>,
      },
      {
        path: 'service/faq',
        element: <LazyWrapper><FAQPage /></LazyWrapper>,
      },
      {
        path: 'service/contact',
        element: <LazyWrapper><ContactPage /></LazyWrapper>,
      },
      {
        path: 'service/terms',
        element: <LazyWrapper><TermsPage /></LazyWrapper>,
      },
      {
        path: 'service/privacy',
        element: <LazyWrapper><PrivacyPage /></LazyWrapper>,
      },
      {
        path: 'service/return-policy',
        element: <LazyWrapper><ReturnPolicyPage /></LazyWrapper>,
      },
      {
        path: 'service/:serviceId',
        element: <LazyWrapper><ServicePage /></LazyWrapper>,
      },
      {
        path: "page/:slug",
        element: <LazyWrapper><GenericPage /></LazyWrapper>,
      },
      {
        path: 'order/checkout',
        element: <LazyWrapper><CheckoutPage /></LazyWrapper>,
      },
      {
        path: 'order/:orderId/confirmation',
        element: <LazyWrapper><OrderConfirmationPage /></LazyWrapper>,
      }
    ],
  },
]);
